import { createSlice } from "@reduxjs/toolkit";

import { type NotificationStateType } from "../interfaces/notification";

const initialState: NotificationStateType = {
  isLoading: false,
  notifications: [
    {
      id: "1",
      title: "System Maintenance Notice",
      message:
        "Our system will undergo scheduled maintenance from 2:00 AM to 4:00 AM EST. During this time, some features may be temporarily unavailable.",
      type: "Information",
      targetAudience: "All Users",
      sendPushNotification: true,
      sendEmailNotification: false,
    },
    {
      id: "2",
      title: "New Feature Release",
      message:
        "We're excited to announce the release of our new dashboard analytics feature. Check it out in your dashboard!",
      type: "Success",
      targetAudience: "Administrators",
      sendPushNotification: true,
      sendEmailNotification: true,
    },
    {
      id: "3",
      title: "Security Alert",
      message:
        "We detected suspicious activity on your account. Please review your recent login activity and update your password if necessary.",
      type: "Warning",
      targetAudience: "All Users",
      sendPushNotification: true,
      sendEmailNotification: true,
    },
    {
      id: "4",
      title: "Payment Failed",
      message:
        "Your recent payment attempt failed. Please update your payment method to continue using premium features.",
      type: "Error",
      targetAudience: "Premium Users",
      sendPushNotification: false,
      sendEmailNotification: true,
    },
  ],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    addNotification: (state, action) => {
      state.notifications.push(action.payload);
    },
    updateNotification: (state, action) => {
      const index = state.notifications.findIndex(
        (n) => n.id === action.payload.id,
      );
      if (index !== -1) {
        state.notifications[index] = action.payload;
      }
    },
    removeNotification: (state, action) => {
      state.notifications = state.notifications.filter(
        (n) => n.id !== action.payload,
      );
    },
  },
});

export const {
  setNotificationLoading,
  setNotifications,
  addNotification,
  updateNotification: updateNotificationAction,
  removeNotification,
} = notificationSlice.actions;
export default notificationSlice.reducer;
